<template>   
    <div class="whiteBG chatbox right-chatBlock w-100" > {{upateFunc}}
        <loader v-if="pageLoader && !$parent.ticketUpdate"></loader>
        <alert-notification v-if="notification_msg != ''"/>
        <!--<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader && !type_ticket_detail"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
        <div v-if="ticketView != ''">
            <div class="ChatHead d-flex flex-wrap align-items-center justify-content-between px-3 pb-2 mb-3">
                <div class="title section_title mb-0"> 
                    <h5 class="mb-1"  v-if="parseInt(ticketView.ticket[0].title) !== 0"> 
                        <span class="mb-1" v-for="list in ticketReasonList[ticketView.ticket[0].reason].categories" v-if="list.id == ticketView.ticket[0].title">{{list.title}}</span>
                    </h5>
                    <h5 class="mb-1 d-flex" v-else>
                        <div class="blockFts">
                            <span>{{ticketReasonList[ticketView.ticket[0].reason].title}}</span>
                        </div>
                    </h5>
                    <div class="btdPf d-flex align-items-center">
                      <p class="mb-0">Ticket Number: <strong>{{ticketView.ticket[0].ticketnumber}}</strong></p>
                       <div class="fts">
                            <small>{{ticketView.ticket[0].created | moment("DD MMMM")}}</small>
                        </div>
                    </div>
                </div>
                <div class="ticketnumber_in">
                    <router-link to="/help-centre" class="d-flex align-items-center cap_btn blue"><feather type="chevron-left" class="mr-1"></feather> Support Home</router-link>
                </div>
            </div>
            <div class="scrollbar ticket" v-chat-scroll>
                <div class="msg_history">
                    <div class="loader" v-if="type_ticket_detail"></div>
                    <div class="msg_history">
                        <div class="outgoing_msg">
                            <div class="d-flex justify-content-end">
                            <div class="sent_msg">
                                <div class="singleUpload" >
    								<div class="fr-view" >
    									<span class="mb-0" v-html="ticketView.ticket[0].comment"><span></span></span>    
    								</div> 
    								<span class="time_date"> {{ticketView.ticket[0].created  | moment("DD MMMM YYYY")}}</span>
                                </div>
                                </div>
                                <div class="incoming_msg_img"> 
                                  <feather type="user"></feather>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="msg_history" v-for="(ticketThread,index) in ticketView.threads">
                        <div class="incoming_msg d-flex" v-if="parseInt(ticketThread.ticket_updatedby) == 1">
                            <div class="incoming_msg_img"> 
                                <feather type="user"></feather>
                            </div>
                            <div class="received_msg">
                                <froalaView v-model="ticketThread.message" v-if="ticketThread.message != '' && ticketThread.docs.length == 0"></froalaView>
                                <div class="midScale" v-for="ticketThreadDoc in ticketThread.docs" :class="parseInt(ticketThreadDoc.status) == 2? 'greenClass11': parseInt(ticketThreadDoc.status) == 1? 'redClass11': 'pendingClass11'">
                                    <div class="attached_msg d-flex align-items-center justify-content-between">
                                        <p class="completeStatus greenBG">Approved</p>
                                        <p class="completeStatus redBG">Declined</p>
                                        <p class="completeStatus pendingBG">Pending</p>
                                        <!-- <p class="p-0">
                                            <span><feather type="paperclip"></feather> </span> 
                                        </p> -->
    								
                                        <a :href="$env_var.docsLink+'user&id='+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 94 || parseInt(ticketView.ticket[0].reason) == 92 || parseInt(ticketView.ticket[0].reason) == 115">
                                            <span class="fileText"><feather type="file-text"></feather> </span>
                                            <span class="tikStatus">{{ticketThreadDoc.document_name}}</span>
                                            <span class="clickIcon"><feather type="eye"></feather></span>
                                        </a>
                                        <a :href="$env_var.docsLink+'ticket&id='+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link" target="_blank()" v-else>
                                             <span class="fileText"><feather type="file-text"></feather> </span>
                                            <span class="tikStatus">{{ticketThreadDoc.document_name}}</span>
                                            <span class="clickIcon"><feather type="eye"></feather></span>
                                        </a>
                                    </div>
                                    <div class="ticketThreadDoc" v-if="parseInt(ticketView.ticket[0].reason) != 91 && parseInt(ticketView.ticket[0].reason) != 92 && parseInt(ticketView.ticket[0].reason) != 115">
    									<froalaView v-model="ticketThreadDoc.msg" v-if="ticketThreadDoc.msg != '' && parseInt(ticketThreadDoc.status) == 1"></froalaView>
                                    </div>
                                </div>
                                <span class="time_date"> {{dateFunction(ticketThread.created)}}</span>
                            </div>
                        </div>
                        <div class="outgoing_msg" v-if="parseInt(ticketThread.ticket_updatedby) == 0">
                            <div class="d-flex justify-content-end">
	                            <div class="sent_msg">
	                                <froalaView v-model="ticketThread.message" v-if="ticketThread.message != '' && ticketThread.docs.length == 0"></froalaView>

	                                <div class="midScale" v-for="ticketThreadDoc in ticketThread.docs" :class="parseInt(ticketThreadDoc.status) == 2? 'greenClass11': parseInt(ticketThreadDoc.status) == 1? 'redClass11': 'pendingClass11'">
                                        <div class="attached_msg d-flex align-items-center justify-content-between">
                                            <p class="completeStatus greenBG">Approved</p>
                                            <p class="completeStatus redBG">declined</p>
                                            <p class="completeStatus pendingBG">Pending</p>
    										
    	                                   <!--  <p class="p-0">
    	                                        <span><feather type="paperclip"></feather> </span>
    	                                    </p> -->
    	                                    <a :href="$env_var.docsLink+'user&id='+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link" target="_blank()" v-if="parseInt(ticketView.ticket[0].reason) == 91 || parseInt(ticketView.ticket[0].reason) == 92 || parseInt(ticketView.ticket[0].reason) == 94 || parseInt(ticketView.ticket[0].reason) == 115">
    	                                        <span class="fileText"><feather type="file-text"></feather> </span>
    	                                        <span class="tikStatus">{{ticketThreadDoc.document_name}}</span>
    	                                         <span class="clickIcon"><feather type="eye"></feather></span>
    	                                    </a>
    	                                    <a :href="$env_var.docsLink+'ticket&id='+ticketView.ticket[0].user_id+'&doc='+ticketThreadDoc.document" class="contract_link" target="_blank()" v-else>
    	                                        <span class="fileText"><feather type="file-text"></feather> </span>
    	                                        <span class="tikStatus">{{ticketThreadDoc.document_name}}</span>
    	                                         <span class="clickIcon"><feather type="eye"></feather></span>
    	                                    </a>
                                        </div>
                                        <div class="ticketThreadDoc" v-if="parseInt(ticketView.ticket[0].reason) != 91 && parseInt(ticketView.ticket[0].reason) != 92 && parseInt(ticketView.ticket[0].reason) != 115">
    										<froalaView v-model="ticketThreadDoc.msg" v-if="ticketThreadDoc.msg != '' && parseInt(ticketThreadDoc.status) == 1"></froalaView>
                                        </div>
	                                </div>
	                                <span class="time_date"> {{dateFunction(ticketThread.created)}}</span> 
	                            </div>
	                            <div class="incoming_msg_img"> 
	                                <feather type="user"></feather>
	                            </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
            <div class="type_msg" v-if="ticketView.ticket && parseInt(ticketView.ticket[0].status) != 3">
				<form action="" method="post" enctype="multipart/form-data" id="TicketReplyForm" v-on:submit.prevent="submitNow()">
					<div class="input_msg_write d-flex justify-content-between align-items-center position-relative">
                        <!--Static Upload Design-->
						<div class="showOnclick gooeyMenu" v-if="parseInt(ticketView.ticket[0].reason) == 91 && parseInt(get_user.lead_type) == 0"> 
						
							<div class="uploadShowMenu" :class="setUpFxaccount?'active':' '">
								<ul class="listAnimated setUpFxaccount">
									<li class="bt1" v-for="val in fileNames" >	
										<div class="sptIcon">
											<feather size="16px" type="upload"></feather>
										</div>
										<div class="upload-btn-wrapper" @click="docType = val; $refs.file.click()" >
										      <a class="btn"  href="#" @click="docType = val">{{val.value}}</a>
										</div>
									</li>
									
								</ul>	
							</div>
						</div>
						
						<div class="upload-btn-wrapper mr-2" v-else>
							<div class="d-flex align-items-center"  @click="$refs.file.click()">
								<feather type="paperclip" class="mr-1"></feather> 
							</div>
						</div>
						
						<div class="upload-btn-wrapper mr-2" >
							<input type="file" name="document[]" style="display:none" id="docfile" ref="file" @change="onFileChange($event.target.name, $event.target.files)" v-validate="{required: (text == '')}"/> 
						</div>
						
						
                        <!--Static Upload Design-->
						<div class="showDocument" v-if="document != ''">
							<div class="showDocument-group">
								<div class="ftIco">
									<feather type="file"></feather>
								</div>
								<p class="m-0">{{document}} <feather class="closeIt" type="x" @click="clear_doc()"></feather>
								</p>
								<span class="sizeSM">2.14kb</span>
							</div>
						</div>
						
						
						
						<span class="alert alert-danger position-absolute erroMT" v-if="submitted && (errors.has('document[]') ||  errors.has('message'))">Please fill atleast one field</span>
						<input type="hidden" name="ticket_id" :value="ticketView.ticket[0].id">
					
						<textarea class="write_msg" placeholder="Type a message" v-model="text" name="message" v-validate="{required: errors.has('document[]')}"></textarea>
					    <div class="input_msg_write_btn d-flex align-items-center" >
							<div class="uploadGooey setUpFxaccount" :class="setUpFxaccount?'active':' '" v-if="parseInt(ticketView.ticket[0].reason) == 91 && parseInt(get_user.lead_type) == 0">   
		                    	<a @click="setUpFxaccount = !setUpFxaccount" href="#">
		                    		<feather class="addIB" type="plus"></feather> 
		                    		<feather class="closeIB" type="x"></feather> 
		                    	</a>
		                    </div>
							<button class="msg_send_btn" :class="[(text == '' && document == '')?'disabled' : '',{'disabled' : pageLoader }]"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path></svg></button>
						</div>
					</div>
					<!-- <span class="text-danger bottmErro" v-if="submitted && errors.has('message')">{{ errors.first('message') }}</span> -->
				</form> 
            </div>
        </div>
    </div> 
</template>
<script>
    import { supportMixins } from '@/plugins/support'
    import moment from 'moment'
    export default {
        name: 'View-TICKET',
        mixins: [supportMixins],
        data () {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                submitted : false,
                notification_msg:'',
                notification_type:'',
                type_ticket_detail : false,
                setUpFxaccount : false,
                submit: false,
                loaderFuncRun : '1',
                //update_id : '',
                //==========================================
                document : '',
				invidual_file:{},
				
				frontBackOption : false,
				
                text : '', 
                config: {
                    placeholder: "Edit Me",
                    key: 'ERB2zH3C1A8A2B2A1qYFd1UQRFQIVb1MSMc2IWPNe1IFg1yD4C3D2D2C4C1G1H4B1C1=='
                },
				docType : '',
				fileNames:[
                    { name:'Passport',value:'Passport',type:'Proof_of_Identity'},
                    { name:'Drivers_License_BACK',value:'Drivers License Back',type:'Proof_of_Identity'},
					{ name:'Drivers_License_FRONT',value:'Drivers License Front',type:'Proof_of_Identity'},
                    { name:'Government_Issued_Photo_ID_BACK',value:'Government Issued Photo ID Back',type:'Proof_of_Identity'},
					{ name:'Government_Issued_Photo_ID_FRONT',value:'Government Issued Photo ID Front',type:'Proof_of_Identity'},
                    { name:'Bank_Credit_Card_Statement',value:'Bank Statement/Credit Card Statement',type:'Proof_of_Residence'},
                    { name:'Utility_Bill',value:'Utility Bill',type:'Proof_of_Residence'},
                    { name:'Payroll_Statement',value:'Payroll Statement',type:'Proof_of_Residence'},
                    { name:'Tax_Document',value:'Tax Document',type:'Proof_of_Residence'},
                    { name:'Photo_Verification',value:'Photo Verification',type:'Photo_Verification'}
                ]
            }
        },
        computed:{
			upateFunc(){
				if(this.$parent.ticketUpdate == true){
					
					this.ticketDetail()
				}
			}
		},
		methods:{
            clear_doc(){
                this.document = ''
                document.getElementById('docfile').value = ''
            },
            clear(){
				this.document = ''
                document.getElementById('docfile').value = ''
			
                this.invidual_file = {};
                this.text = ''
                this.docType = ''
				this.setUpFxaccount = false
				this.submitted = false
            },
            dateFunction(getDate){
                let last_seen_date = moment(getDate).fromNow();
                return last_seen_date;
            },
            ticketDetail(){
                let input_json={
                    'globalParams' :{
                        'ticket_id' : this.$route.query.id
                    },
                    'localParams' :{ "parameter" : this}
                }
                this._runGetTicketDetail(input_json)
            },
            onFileChange(fieldName, file) {
				this.document = file[0].name,
				this.setUpFxaccount = false
				if(parseInt(this.ticketView.ticket[0].reason) == 91 && parseInt(this.get_user.lead_type) == 0){
					this.invidual_file['file'] = file[0];
					this.invidual_file['name'] = file[0].name;
				}
            },
            submitNow(){
                if(this.pageLoader){return;}
                const _that = this
                _that.submitted = true;
                _that.$validator.validate().then(valid => {
                    if (valid) {  
		                let TicketReplyForm = document.getElementById('TicketReplyForm');
		                let form_name = new FormData(TicketReplyForm);
		                
						if(parseInt(_that.ticketView.ticket[0].reason) == 91 && parseInt(_that.get_user.lead_type) == 0 && this.document != ''){
		                    form_name = new FormData();
							
		                    form_name.append('document[]', _that.invidual_file.file, _that.docType.name+ '.'+ _that.invidual_file.name.split('.')[_that.invidual_file.name.split('.').length -1] );
							
		                    form_name.append('documenttype', _that.docType.type);
		                    form_name.append('message', _that.text);
		                    form_name.append('ticket_id', _that.ticketView.ticket[0].id);
		                }
						if((parseInt(_that.ticketView.ticket[0].reason) == 91 || parseInt(_that.ticketView.ticket[0].reason) == 92) && this.document != ''){
		                    form_name.append("type", 'user');
		                }
						
		                let input_json =  {
		                    'globalParams' :{
		                        "form" : form_name
		                    },
		                    'localParams' :{ "parameter" : _that ,'type' :'form','tick_id' : _that.ticketView.ticket[0].id }
		                };
		                // console.log(input_json)
		                _that._runTicketReply(input_json)
                    }
                });
            }
        },
        created(){
            this.ticketDetail()
        },
        mounted() {
            const _that = this
            $(document).on("click", function(event){
                if(!$(event.target).closest('.setUpFxaccount').length){
                    _that.setUpFxaccount = false
                }
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/website/supports/view.vue